"use client";
import dynamic from "next/dynamic";
import React from "react";
import Link from "next/link";
// import BgHeader from "/public/assets/eternal-slots-home-page-banner-instant-withdrawals-desktop.webp";
// import BgHeaderTablet from "/public/assets/eternal-slots-home-page-banner-instant-withdrawals-tablet.webp";
// import BgHeaderMobile from "/public/assets/eternal-slots-home-page-banner-instant-withdrawals-mobile.webp";

// import MainCharacter from "/publi/assets/main-character.png";
// import SliderPromoHome from "./SliderPromoHome";
import MainTxtPromo_1 from "../../public/images/goat-spins-45-free-spins-easy-signup.svg";
import BigBtns from "../components/BigBtns";
// import { useNavigate } from "react-router-dom";
import { useRouter } from "next/navigation";
import Image from "next/image";
import ResponsiveHomeImage from "./ResponsiveHomeImage";
import BarTop from "./BarTop";

const SliderPromoHome = dynamic(() => import("./SliderPromoHome"));
// const SliderPromoHome = dynamic(() => import("./SliderPromoHome"), {
//   ssr: false,
// });

export default function HomeHeader({ showSlider }) {
  // const navigation = useNavigate();
  const router = useRouter();

  // const handleClick = () => navigation('/promotions');
  const handleClick = () => router.push("/promotions");

  return (
    <div className="HomeHeader NoSelect" id="HomeHeader">
      <BarTop />
      {/* <Image
        width={1000}
        height={500}
        src={BgHeader}
        priority={true}
        className="ImgHeaderBg HeaderBg_Desk"
        alt="goat-spins-home-page-banner-instant-withdrawals-desktop"
      /> */}
      {/* <Image
        width={700}
        height={500}
        src={BgHeaderTablet}
        priority={true}
        className="ImgHeaderBg HeaderBg_Tab"
        alt="goat-spins-home-page-banner-instant-withdrawals-tablet"
      /> */}
      {/* <Image
        src={BgHeaderMobile}
        priority={true}
        className="ImgHeaderBg HeaderBg_Mob"
        alt="goat-spins-home-page-banner-instant-withdrawals-mobile"
        width={500}
        height={600}
        sizes="100vw"
        style={{
          width: "100%",
          height: "auto",
        }}
      /> */}
      <ResponsiveHomeImage />
      <div className="Cont_L0 MoveBounce"></div>
      <div className="Cont_L1">
        {/* <img src={MainCharacter} className="ImgCharacter AniCharacter" alt="goat spins" /> */}
      </div>
      {/* BOXES PROMOS */}
      {/* <div className="RowFrontBoxes">
        <div className="CenterBoxes">
          <div
            onClick={handleClick}
            style={{ cursor: "pointer" }}
            className="PromoBoxes"
          >
            <div className="img-div">
              <Image
                width={320}
                height={120}
                src={MainTxtPromo_1}
                className="ImgPromos"
                alt="goat spins"
                priority
              />
            </div>
            <div className="btn-div">
              <BigBtns
                className="BigBtns Cyan"
                text="Play Now"
                onClick={handleClick}
              />
            </div>
          </div>
        </div>
      </div> */}

      {showSlider == 1 ?
        <>
          <div className="responsive-space"></div>
          <div className="RowProBoxes">
            <SliderPromoHome />
          </div>
        </> : <></>}
    </div>
  );
}
